module.exports = __webpack_public_path__ + "img/score-background.4d8d10ed.png";